<template>
  <div class="ai-preview">
    <div class="ai-preview__hd">
      <h3 class="main-title">{{ $t('lang.k_149001') }}</h3>
      <p>14:00:00</p>
      <p>{{ $t('lang.k_149002') }}</p>
    </div>
    <div class="ai-preview__bd">
      <h3 class="main-title">{{ $t('lang.k_149003') }}</h3>
      <h3 class="sub-title">{{ $t('lang.k_149004') }}</h3>
      <p>{{ $t('lang.k_149005') }}</p>
    </div>
    <div class="ai-preview__ft">{{ $t('lang.k_149006') }}</div>
  </div>
</template>
<script>
  export default {
    props: {
      menuInfo: {
        required: false
      }
    },
    name: 'component-ai'
  };
</script>
<style lang="less">
  .ai-preview {
    display: flex;
    flex-direction: column;
    height: 100%;
    line-height: 1.5;
    padding: 0 16px;
    font-size: 14px;

    &__hd {
      margin-bottom: 16px;
    }
    &__bd {
      flex: 1;
    }
    &__ft {
      color: #6c6c6c;
      font-size: 12px;
      margin-bottom: 6px;
    }

    .main-title {
      font-size: 16px;
      color: #fb2626;
    }
    .sub-title {
      font-weight: bold;
    }
  }
</style>
